// User and Authentication Types

export const LOGIN_KIND = {
  CADP: 'CADP',
  ENTRA_ID: 'ENTRA_ID',
} as const;

export type LoginKind = (typeof LOGIN_KIND)[keyof typeof LOGIN_KIND];

export interface User {
  loginKind?: LoginKind;
  idPessoa?: number;
  cpf?: string;
  pessoaFisicaResponse?: {
    base: string;
    mensagem: string | null;
    pessoaFisica: {
      id: string;
      nome: string;
      cpf: string;
      dataNascimento: string;
      nomeMae: string;
      sexo: string;
      estadoCivilId: string;
      grauEscolaridadeId: string;
    };
  };
  chaveM?: string;
  email?: string;
}

export interface AuthData {
  user: User;
}
